<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>基础数据</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/college/list'}">院校管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: `/college/${this.$route.params.collegeId}/academy`}">学院管理</el-breadcrumb-item>
        <el-breadcrumb-item>专业管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">专业管理</h2>
        </div>
        <div class="right">
          <el-button class="button" type="primary" @click="handleAcademyCreate">添加专业</el-button>
        </div>
      </div>
    </div>
    <div class="info card">
      <div class="info-item">
        <span class="label">院校名称：</span>
        <span class="value">{{academy.college_name}}</span>
      </div>
      <el-divider class="divider" direction="vertical"></el-divider>
      <div class="info-item">
        <span class="label">院校代码：</span>
        <span class="value">{{academy.college_code}}</span>
      </div>
      <el-divider class="divider" direction="vertical"></el-divider>
      <div class="info-item">
        <span class="label">学院名称：</span>
        <span class="value">{{academy.name}}</span>
      </div>
      <el-divider class="divider" direction="vertical"></el-divider>
      <div class="info-item">
        <span class="label">学院代码：</span>
        <span class="value">{{academy.code}}</span>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="专业名称"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="code"
            label="专业代码"
            min-width="100"
            align="center">
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToMajorRemove(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <AcademyMajorCreate :visible="createDialog" :academy="academy" @close="createDialog = false" @submit="fetchMajorList"></AcademyMajorCreate>
  </div>
</template>

<script>
import AcademyMajorCreate from '@/components/dialog/college/AcademyMajorCreate'
import { academyMajorList, academyMajorDestroy, academyOne } from '@/api/common'

export default {
  components: {
    AcademyMajorCreate
  },
  data() {
    return {
      createDialog: false,
      editRow: {},
      query:  {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      academy: {},
      results: []
    }
  },
  created() {
    this.parseQuery()
    this.fetchAcademyInfo()
  },
  methods: {
    fetchAcademyInfo() {
      academyOne({id: this.$route.params.academyId}).then(res => {
        this.academy = res

        this.fetchMajorList()
      })
    },
    // 专业列表请求
    fetchMajorList() {
      let params = {...this.query}
      params.academy_code = this.academy.code
      params.college_code = this.academy.college_code
      academyMajorList(params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchMajorList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchMajorList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchMajorList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchMajorList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '2': '关闭'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 专业创建
    handleAcademyCreate() {
      this.createDialog = true
    },
    // 专业编辑
    handleToMajorRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        academyMajorDestroy({id: row.id}).then(res => {
          this.$message.success(`删除成功`)
          this.fetchMajorList()
        })
      }).catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .info {
    display: flex;
    margin-top: 10px;

    .info-item {
      .label {
        color: #909399;
      }
      .value {
        // margin-left: 5px;
      }
    }
    .divider{
      margin: 0 20px;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {

    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
